export default "__VITE_ASSET__Coj74hOI__"